import { HTMLAttributeAnchorTarget } from 'react'

import { useIntl } from 'react-intl'

import { useConfiguration } from './useConfiguration'
import { SiteMapRoute } from '@app/routes'

type Link = {
  id: string
  title: string
  path: string
  target?: HTMLAttributeAnchorTarget
}

export const useFooterLinks = (): Link[] => {
  const intl = useIntl()

  const { data: configuration } = useConfiguration()

  const siteMapLink = {
    id: 'siteMap',
    title: intl.formatMessage({ id: 'sign_in_page.legal_links.site_map.title' }),
    path: `/${SiteMapRoute.toString()}`,
  }

  if (!configuration) return [siteMapLink]

  return [
    {
      id: 'legalNotices',
      title: intl.formatMessage({ id: 'sign_in_page.legal_links.legal_notice.title' }),
      path: configuration.urls.legalNotices,
      target: '_blank',
    },
    {
      id: 'privacy',
      title: intl.formatMessage({ id: 'sign_in_page.legal_links.privacy_policy.title' }),
      path: configuration.urls.privacy,
      target: '_blank',
    },
    {
      id: 'cgps',
      title: intl.formatMessage({ id: 'sign_in_page.legal_links.cgu.title' }),
      path: configuration.urls.cgps,
      target: '_blank',
    },
    {
      id: 'cookies',
      title: intl.formatMessage({ id: 'sign_in_page.legal_links.cookies.title' }),
      path: configuration.urls.cookies,
      target: '_blank',
    },
    siteMapLink,
  ]
}
